import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type { Merchant } from '../model/merchant';

export async function getMerchants(): Promise<Merchant[]> {
  const res = await makeRequest<{ payload: Merchant[] }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${config.apiHost}/merchant-portal/api/v1/public/merchants/find-all-by-employee-id`,
    withCredentials: true,
    timeout: 60_000,
  });
  return res.payload;
}
